import { Trans, useTranslation } from 'react-i18next';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@mui/material';

function UnsubmitDialog({ open, onClose, onSubmit, status }) {
    const date = status.month.toLocaleDateString('de-de', { month: 'long', year: 'numeric' });
    const { t } = useTranslation();

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
            >
                <DialogTitle>
                    {status.user.name}, {date} - <Trans i18nKey='freigabeAufheben' ns='statusOverviewPage'>Freigabe aufheben</Trans>?
                </DialogTitle>
                <DialogContent>
                {t('dialogFreigabeAufheben', { date: date, userName: status.user.name, ns:'statusOverviewPage', defaultValue: 'Möchtest Du die Freigabe für {{date}}  aufheben? {{userName}} kann die Arbeitseinträge für diesen Monat dann wieder bearbeiten.' })}
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>
                        <Trans i18nKey='abbrechen' ns='statusOverviewPage'>Abbrechen</Trans>
                    </Button>
                    <Button variant='contained' onClick={() =>{
                         onSubmit(status.user.id, status.month);
                         onClose();
                    }}>
                        <Trans i18nKey='freigabeAufheben' ns='statusOverviewPage'>Freigabe aufheben</Trans>
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default UnsubmitDialog